import React, { Component } from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import DigitalTransformation from 'views/digitalTransformation';
import Layout from 'components/layout';
import { NavBar, PopupRedirect } from 'components';
import { pages } from 'config/pages';
import config from '../../meta/config';

class DigitalTransformationPage extends Component {
  render() {
    const page = pages['digital-transformation'];
    const { navColors } = page;
    const canonical = `${config.siteUrl}/digital-transformation/`;

    const { data } = this.props;
    const { allArticles } = data || {};

    return (
      <Layout {...{page, canonical}}>
        <Helmet title="Digital Transformation">
          <meta
            name={'description'}
            content={
              'Whether you’re looking to disrupt your department or entire industry Boldare teams will show you how you can make it happen.'
            }
          />
          <link rel="canonical" href={canonical} />
        </Helmet>
        <NavBar color={navColors} />
        <PopupRedirect />
        <DigitalTransformation allArticles={allArticles} />
      </Layout>
    );
  }
}

export const pageQuery = graphql`
  query DigitalTransformationPage {
    allArticles: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___settings___date] }
      filter: {
        frontmatter: {
          title: {
            in: [
              "Visualising Energy"
              "How to scale a monolithic MVP application without losing business?"
              "From design to development in 4 weeks. Creating a mobile and web MVP for an iconic brand"
              "Designing a simple search experience for a complex product with a luxurious interface"
            ]
          }
        }
      }
    ) {
      ...markdownFields
      ...boxMarkdownFields
    }
  }
`;

export default DigitalTransformationPage;
